import { useContext } from "react";

import type { Treatment } from "api/types/Treatment";
import { CurrentPatientContext } from "utils/contexts";

export const useCurrentPatient = () => {
  const { patient, ...rest } = useContext(CurrentPatientContext);
  const treatments = patient?.treatments as Treatment[] | undefined;

  const currentTreatment = treatments?.find(treatment => treatment.is_current_treatment);

  return {
    patient,
    currentTreatment,
    ...rest,
  };
};
